import { useRecoilValue } from "recoil";
import { permissionsSelector } from "../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../../PermissionsConstants";
import CustomReportTable from "./view/CustomReportTable";

interface Props {}

export const CustomReport: React.FC<Props> = () => {
  const viewPermission = PERMISSIONS.permission_utilities_customreport_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <> {userPermissions.includes(viewPermission) && <CustomReportTable />} </>
  );
};
